import {Component, OnInit, ViewChild} from "@angular/core";
import {DxPageOptions} from "../../../../dx-page-markup/domain/ui-options/page/dx-page-options";
import {BdpkConfigService} from "../../../../bdpk-common/services/bdpk-config.service";
import {DxNavigatorOptions} from "../../../../dx-navigation/domain/ui-options/dx-navigator/dx-navigator-options";
import {PitNavigationMenuItem} from "../../../domain/pit-navigation-menu-item";
import {PitNavigationService} from "../../../services/pit-navigation.service";
import {DxNavigationTreeNodeDataProvider} from "../../../../dx-navigation/domain/navigator/dx-navigation-tree-node-data-provider";
import {ActivatedRoute, Router} from "@angular/router";
import {DxNciDictionary} from "../../../../dx-nci-core/domain/dx-nci-dictionary";
import {DxNciService} from "../../../../dx-nci-core/services/dx-nci.service";
import {PitPageHeaderComponent} from "../../../../pit-common/ui/components/pit-page-header/pit-page-header.component";


/** Прикладной навигатор по системе План-ИТ.  */
@Component({
  selector: 'pit-navigator',
  templateUrl: './pit-navigator.component.html',
  styleUrls: ['./pit-navigator.component.css']
})
export class PitNavigatorComponent implements OnInit {
  private _isLoading: boolean = true;
  private readonly _pageOptions: DxPageOptions;
  private readonly _navigatorOptions: DxNavigatorOptions;
  private _topMenuItems: PitNavigationMenuItem[];
  private _sideMenusMap: Map<number, DxNavigationTreeNodeDataProvider[]> = new Map();
  /** Справочник бюджетных периодов */
  private _budgetPeriods: DxNciDictionary;

  constructor(private _configService: BdpkConfigService,
              private _router: Router,
              private _route: ActivatedRoute,
              private _nciService: DxNciService,
              private _navigationService: PitNavigationService) {
    this._pageOptions = new DxPageOptions();
    this._pageOptions.withoutPageSide = true;
    this._navigatorOptions = this._configService.bdpkNavigatorOptions;
  }

  @ViewChild(PitPageHeaderComponent, {static: false})
  private _pageHeaderRef:PitPageHeaderComponent;

  ngOnInit(): void {
    this._fetchData();
  }

  get isLoading(): boolean {
    return this._isLoading;
  }

  get pageOptions(): DxPageOptions {
    return this._pageOptions;
  }

  get navigatorOptions(): DxNavigatorOptions {
    return this._navigatorOptions;
  }

  get topMenuItems(): PitNavigationMenuItem[] {
    return this._topMenuItems;
  }

  get sideMenusMap(): Map<number, DxNavigationTreeNodeDataProvider[]> {
    return this._sideMenusMap;
  }


  private _fetchData(): void {
    this._isLoading = true;
    this._navigationService.fetchTopMenu().subscribe(topMenuItems => {
      this._topMenuItems = topMenuItems;
      this._isLoading = false;
    });
  }
}
